import React from 'react'
import { LayoutBaseRoot } from './LayoutBase.style'

const LayoutBase = ({ children }) => {
  return <LayoutBaseRoot>{children}</LayoutBaseRoot>
}

export default LayoutBase
